// Social Features Constants

// Follow relationship statuses
export const FOLLOW_STATUSES = {
	NOT_FOLLOWING: "not_following",
	PENDING: "pending",
	ACCEPTED: "accepted",
	REJECTED: "rejected",
	SELF: "self",
} as const;

export type FollowStatusValue =
	(typeof FOLLOW_STATUSES)[keyof typeof FOLLOW_STATUSES];

// Notification types
export const NOTIFICATION_TYPES = {
	FOLLOW_REQUEST: "follow_request",
	FOLLOW_ACCEPTED: "follow_accepted",
	FOLLOW_REJECTED: "follow_rejected",
	FESTIVAL_INVITE: "festival_invite",
	REVIEW_LIKED: "review_liked",
} as const;

export type NotificationType =
	(typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

// Note: Privacy is now simplified to a boolean is_private field
// These granular privacy constants are no longer used
